import { createFileRoute } from "@tanstack/react-router";
import { PortalReportsPage } from "@/features/portalforms/PortalReportsPage";

/** Portal reports (P109): the status updates sent to the client, grouped by month. */
export const Route = createFileRoute("/portal/reports")({ component: PortalReportsPage });
